(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-price-list"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.dynamicVariantPriceListInfoInitialized) return;
    window.dynamicVariantPriceListInfoInitialized = true;

    const closeInfoBoxes = (except) => {
      document.querySelectorAll('.variant-price-list__info-button[aria-expanded="true"]').forEach((button) => {
        if (button !== except) button.setAttribute('aria-expanded', 'false');
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.variant-price-list__info-button');

      if (!button) {
        closeInfoBoxes();
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      closeInfoBoxes(button);
      button.setAttribute('aria-expanded', String(willOpen));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeInfoBoxes();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
